<div class="main-container">
  <div class="container d-flex" style="gap: 82px; align-items: flex-start;padding: 32px 0 48px;">
    <div class="left-container" [ngClass]="{
      'max-widdth': type === 'SIGNUP',
      'w-100': isHiddenImage,
      'ffssf': isHiddenImage
    }">
      <ng-container *ngIf="!hideHeader">
        <h3 class="title">{{title}}</h3>
        <p class="mb-4">{{subTitile}}</p>
      </ng-container>
      <ng-content></ng-content>
    </div>
    <div class="right-container" *ngIf="!isHiddenImage">
      <div class="image-container">
        <img [src]="sideImage || 'assets/svg/authImage.svg' " alt="Image" class="img-fluid">
      </div>
    </div>
  </div>
</div>